import React, { useState } from "react";
import '../chats/chat.css'
function Carousel({ msg, lang,detectLanguage}) {
  const [showAll, setShowAll] = useState(false);

  if (msg?.payload?.type !== "carousel") return null;

  const items = msg.payload.items;
  const visibleItems = showAll ? items : items.slice(0, 2);
  return (
    <div className="container" style={{ marginTop:'10px' }}>
    <div className="carousel-container" >
      {visibleItems?.map((item, idx) => (
        <div key={idx} className="carousel-main" 
        style={{direction:detectLanguage(item.title) == "ar"? "rtl": "ltr"}}>
          <h4 style={{ margin: "0 0 5px 0", fontSize: 15, fontWeight: "600" }}>
            {item.title}
          </h4>

          <p style={{ margin: "0 0 8px 0", fontSize: 13, color: "#555" }}>
            {item.subtitle}
          </p>
        </div>
      ))}
       
    {items.length > 2 && (
        <button
          onClick={() => setShowAll(!showAll)}
          style={{
            background: "transparent",
            border: "none",
            color: "#007bff",
            fontSize: 12,
            cursor: "pointer",
            fontWeight: "500",
            display:"flex",
            justifyContent:"flex-end"

          }}
        >
          {showAll ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
    </div>

  );
}
export default Carousel;
